import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingMatrixStopwatch } from '../../../../mechanics/rid-reading-matrix-stopwatch/rid-reading-matrix-stopwatch';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-reading-matrix-stopwatch-page',
  imports: [RidReadingMatrixStopwatch],
  templateUrl: './reading-matrix-stopwatch-page.html',
})
export class ReadingMatrixStopwatchPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly previousDuration = computed(() => parseInt(this.queryParams()['previous-duration'] ?? '30'));
}
